window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: largeDesktopShow,
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  sections.register("header", theme.headerCategoryMenu);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("faq-collapse", theme.accordion);
  sections.register("popup-video", theme.video);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});
document.addEventListener('DOMContentLoaded', function () {
  let activeClone = null;
  let activeItem = null;
  let hideTimer = null;

  function removeClone() {
  if (activeClone) {
    activeClone.remove();
    activeClone = null;
  }

  document.body.classList.remove('nichies-portal-open');
  activeItem = null;
}

  function scheduleRemove() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(removeClone, 160);
  }

  function positionClone() {
  if (!activeClone || !activeItem) return;

  const trigger = activeItem.querySelector(':scope > .header__menu_item');
  const header = document.querySelector('.header__sticky, .header_bottom');

  if (!trigger || !header) return;

  const triggerRect = trigger.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();

  const dropdownWidth = activeClone.offsetWidth || 260;

  /* center dropdown under the hovered menu item */
  let left = triggerRect.left + (triggerRect.width / 2) - (dropdownWidth / 2);

  /* keep it inside screen edges */
  left = Math.max(12, Math.min(left, window.innerWidth - dropdownWidth - 12));

  activeClone.style.right = 'auto';
  activeClone.style.left = `${left}px`;
  activeClone.style.top = `${headerRect.bottom + 14}px`;
}

  function showSubmenu(item) {
    const submenu = item.querySelector(':scope > .header__sub_menu');
    if (!submenu) return;

    clearTimeout(hideTimer);
    removeClone();

    activeItem = item;
    activeClone = submenu.cloneNode(true);
    
    document.body.classList.add('nichies-portal-open');

    activeClone.classList.add('nichies-portal-submenu');
    activeClone.classList.remove('color-background-1', 'color-background-2', 'color-scheme-1', 'color-scheme-2');

    document.body.appendChild(activeClone);
    positionClone();

    activeClone.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });

    activeClone.addEventListener('mouseleave', scheduleRemove);
  }

  document.querySelectorAll('.header__menu_li_child_sub_menu').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      showSubmenu(item);
    });

    item.addEventListener('mouseleave', scheduleRemove);

    item.addEventListener('focusin', function () {
      showSubmenu(item);
    });
  });

  window.addEventListener('scroll', positionClone, { passive: true });
  window.addEventListener('resize', positionClone);
});
/* ===== NICHIES QUICK VIEW BODY STATE ===== */
(function () {
  function syncQuickViewState() {
    var isOpen = !!document.querySelector('hooktheme-quick-view[open]');
    document.body.classList.toggle('quick-view-is-open', isOpen);
  }

  document.addEventListener('click', function () {
    setTimeout(syncQuickViewState, 50);
    setTimeout(syncQuickViewState, 200);
  });

  var observer = new MutationObserver(syncQuickViewState);

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['open']
  });

  syncQuickViewState();
})();
/* ===== NICHIES - HIDE WHATSAPP WHEN ANY OVERLAY IS OPEN ===== */
(function () {
  function isVisible(el) {
    if (!el) return false;

    var style = window.getComputedStyle(el);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '0') > 0 &&
      el.offsetWidth > 0 &&
      el.offsetHeight > 0
    );
  }

  function hasOpenOverlay() {
    var searchOverlay = document.querySelector('#predictive__search_overlay');
    var mobileMenu = document.querySelector('.offcanvas-header');
    var mobileMenuOverlay = document.querySelector('.offcanvas-overlay');
    var quickView = document.querySelector('hooktheme-quick-view[open]');

    var searchOpen =
      searchOverlay &&
      (
        searchOverlay.classList.contains('open') ||
        searchOverlay.classList.contains('active') ||
        isVisible(searchOverlay)
      );

    var menuOpen =
      mobileMenu &&
      (
        mobileMenu.classList.contains('open') ||
        mobileMenu.classList.contains('active') ||
        mobileMenu.classList.contains('is-open') ||
        isVisible(mobileMenuOverlay)
      );

    var quickViewOpen = !!quickView;

    return searchOpen || menuOpen || quickViewOpen;
  }

  function syncWhatsappLayer() {
    var widget = document.getElementById('nichies-whatsapp-widget');
    if (!widget) return;

    if (hasOpenOverlay()) {
      widget.style.setProperty('opacity', '0', 'important');
      widget.style.setProperty('visibility', 'hidden', 'important');
      widget.style.setProperty('pointer-events', 'none', 'important');
      widget.style.setProperty('z-index', '-1', 'important');
    } else {
      widget.style.removeProperty('opacity');
      widget.style.removeProperty('visibility');
      widget.style.removeProperty('pointer-events');
      widget.style.removeProperty('z-index');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncWhatsappLayer();

    document.addEventListener('click', function () {
      setTimeout(syncWhatsappLayer, 50);
      setTimeout(syncWhatsappLayer, 200);
      setTimeout(syncWhatsappLayer, 500);
    });

    document.addEventListener('keyup', function () {
      setTimeout(syncWhatsappLayer, 50);
    });

    var observer = new MutationObserver(syncWhatsappLayer);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden']
    });

    setInterval(syncWhatsappLayer, 300);
  });
})();